import { getAnalytics, logEvent } from "firebase/analytics";
import { getApps, initializeApp } from "firebase/app";
import "firebase/auth";
import "firebaseui/dist/firebaseui.css";
import React, { Fragment } from "react";
import { Route, useLocation } from "react-router";
import Button from "~/components/common/atoms/Button";
import { Page404 } from "~/components/common/molecules/Page404";
import Breadcrumb from "~/components/desktop/atoms/Breadcrumb";
import Footer from "~/components/desktop/organisms/Footer";
import FooterAnother from "~/components/desktop/organisms/FooterAnother";
import FooterNew from "~/components/desktop/organisms/FooterNew";
import Header from "~/components/desktop/organisms/Header";
import NavBar from "~/components/mobile/atoms/NavBar";
import * as fire from "~/configs/firebaseConfig";
import AuthenticationMedpro from "~/router_hospitals/AuthenticationMedpro";
import AppId from "~/utils/partner";

export const handleFirebase = () => {
  let firebaseConfig;
  switch (AppId) {
    case "dalieuhcm":
      firebaseConfig = fire.firebase_dalieuhcm;
      break;

    case "nhidong1":
      firebaseConfig = fire.firebase_nhidong1;
      break;
    case "umc":
      firebaseConfig = fire.firebase_umc;
      break;
    case "nhidonghcm":
    case "minhanh":
    case "vanhanh":
    case "choray":
    case "dkanphuoc":
    case "dkdongnai":
    case "medicsaigon":
    case "binhthanhhcm":
      firebaseConfig = fire.firebase_medpro2;
      break;
    default:
      firebaseConfig = fire.firebase_medpro;
      break;
  }

  if (!getApps.length) {
    const app = initializeApp(firebaseConfig);
    const analytics = getAnalytics(app);
    logEvent(analytics, "notification_received");
  }
};

export const handlerHeader = pathname => {
  const hampurge = (
    <Button
      column="column"
      menu="menu"
      icon={<i className="fal fa-bars" />}
      key={1}
    >
      Menu
    </Button>
  );
  const header = () => {
    switch (AppId) {
      default:
        return (
          <Fragment>
            <Header />
            <NavBar hideLeft rightContent={[hampurge]} />
          </Fragment>
        );
    }
  };

  if (
    pathname !== "/iframeMomoTesting" &&
    !(pathname.includes("-app") || pathname.includes("-mobile"))
  ) {
    return header();
  }
  return null;
};

const author = (props, item) => (
  <AuthenticationMedpro ChildComponent={item.component} {...props} {...item} />
);

const noAuthor = (props, item) => (
  <Fragment>
    {item.breadcrumb && <Breadcrumb className="head" />}
    <item.component {...props} />
  </Fragment>
);

export const handerContent = (item, dynamic = false, path) => {
  const _path =
    dynamic && (AppId === "medpro" || AppId === "momo")
      ? `${path}${item.path}`
      : item.path;

  return (
    <Route
      key={item.id}
      path={_path}
      exact
      render={props => {
        return item.authorized ? author(props, item) : noAuthor(props, item);
      }}
    />
  );
};

export const handlerFooter = pathname => {
  const footer = () => {
    switch (AppId) {
      case "nhidonghcm":
        return <FooterAnother />;

      default:
        return <FooterNew />;
    }
  };

  if (
    pathname !== "/iframeMomoTesting" &&
    !(pathname.includes("-app") || pathname.includes("-mobile")) &&
    pathname.indexOf("in-phieu-kham-benh") === -1
  ) {
    return footer();
  }
  return null;
};
export const NoMatch = () => {
  const location = useLocation();

  console.log(
    "%cKhông tìm thấy đường dẫn này, có thể là chưa cấu hình partnerId hoặc router :>> ",
    `color: #ff2200;`,
    location.pathname
  );

  return <Page404 />;
};
